import { useEffect } from 'react';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

declare global {
  interface Window {
    __landingLenis?: Lenis;
    __landingScrollLocked?: boolean;
  }
}

export const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.07,
      anchors: true,
      virtualScroll: () => !window.__landingScrollLocked,
    });
    window.__landingLenis = lenis;

    let raf = 0;
    const loop = (time: number) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };

    raf = requestAnimationFrame(loop);

    return () => {
      cancelAnimationFrame(raf);
      delete window.__landingLenis;
      lenis.destroy();
    };
  }, []);

  return null;
};
